import { faBan, faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import Button from '../atoms/Button'
import Title from '../atoms/Title'

/**
 * CompetitionInvitationModal is a modal that asks the user if they want to send an invitation to a competition
 * @param {{
 *   numberOfTalentsSelected: number;
 *   invitationType: 'email' | 'whatsapp';
 *   onAccept: () => void;
 *   onCancel: () => void;
 * }} props
 */
function CompetitionInvitationModal({
  numberOfTalentsSelected,
  invitationType,
  onAccept,
  onCancel
}) {
  return (
    <div className="w-full p-5 flex flex-col gap-5">
      <div className="w-full flex items-center gap-x-2">
        <FontAwesomeIcon icon={faPaperPlane} size="xl" className="text-smgreen-dark" />
        <Title size="lg">Invitar a una competencia</Title>
      </div>

      <div className="w-full">
        <p>
          ¿Estás seguro de que deseas enviar una invitación a {numberOfTalentsSelected} talento
          {numberOfTalentsSelected !== 1 && 's'} vía{' '}
          {invitationType === 'email' ? 'Email' : 'WhatsApp'}
          ?
        </p>
      </div>

      <div className="w-full flex gap-5 justify-end">
        <Button color="red" icon={faBan} onClick={onCancel}>
          Cancelar
        </Button>
        <Button color="green" icon={faPaperPlane} onClick={onAccept}>
          Aceptar
        </Button>
      </div>
    </div>
  )
}

CompetitionInvitationModal.propTypes = {
  numberOfTalentsSelected: PropTypes.number.isRequired,
  invitationType: PropTypes.oneOf(['email', 'whatsapp']).isRequired,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default CompetitionInvitationModal